"use strict";
/**
 * 一键快签 - 关联管理 - 退回原因
 * 2019-04-29
 * fanglijuan
 */
angular.module("quickSignReasonOfReturnModule", []).
controller("quickSignReasonOfReturnCtrl", ["$scope", "$modalInstance", "$q", "trsHttpService", "obj",
    function($scope, $modalInstance, $q, trsHttpService, obj) {
        initData();

        /**
         * [initData description] 初始化数据
         * @return {[type]} [description]
         */
        function initData() {
            $scope.data = {
                item: obj
            };
        }

        //取消
        $scope.cancel = function() {
            $modalInstance.dismiss();
        };
    }
]);